import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';


@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  
  title = 'playground-v2';

  constructor(
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('language')||"en");
  }

  ngOnInit(): void {
    console.log('App Started');
    this.setV2HostInLocalStorage();
  }

  setV2HostInLocalStorage(): void {
    localStorage.setItem('isStagingV2', 'true');
  }

}
